module.exports = __webpack_public_path__ + "img/group.27ee29f4.png";